
import RadioButton from "../../../assets/outline/RadioButton.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RadioButtonIcon({ className, dataTestid = "RadioButtonIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RadioButton data-testid={dataTestid} className={classes} {...rest} />
  );
}
